<template>
  <div class="form-group form-group--author__no-padding-and-border author-role__flex-col">
    <div class="form-label">
      <label class="control-label">
        作詞 / 作曲 / 補作詞 / 補作曲
        <span class="req">＊</span>
      </label>
    </div>
    <div class="author-roles-row">
      <div class="form-item">
        <div
          v-for="role in author && author.pivot.author_roles"
          :key="role.value"
          class="checkbox">
          <label :for="`author_type_${role.value}_${index}`">
            <input
              :id="`author_type_${role.value}_${index}`"
              v-model="author_roles"
              type="checkbox"
              :value="role"
              :disabled="role.disabled || isDisabled()"
              @change="handleRoleChange(role)">
            <div
              :class="{ 'disabled-checkbox': role.disabled || isDisabled()}"
              class="option-input">
            </div>
            {{ role.label }}
            <i
              v-if="role.value === 'co-composer' || role.value === 'co-lyricist'"
              v-tooltip="role.value === 'co-composer'
                ? pcTooltipConfig(tooltipMessages.co_composer)
                : pcTooltipConfig(tooltipMessages.co_lyricist)"
              class="tooltip-icon">
            </i>
          </label>
        </div>
      </div>
      <div class="copyright-split-rate">
        <input
          v-model="formattedRate"
          type="text"
          class="form-control"
          :disabled="true"
          placeholder="収益の分配率：">
      </div>
    </div>
  </div>
</template>
<script>
import tooltipMessages from '../copyright-tooltips'
import tooltip from '../../../mixins/tooltip'

export default {
  name: 'AuthorRole',
  mixins: [
    tooltip,
  ],
  props: {
    author: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    isConfirm: {
      type: Boolean,
      default: false,
    },
    isInstrumental: {
      type: Boolean,
      default: false,
    },
    tooltipMessages: {
      type: Object,
      default: () => tooltipMessages,
    },
  },
  data() {
    return {
      author_roles: [],
    }
  },
  computed: {
    formattedRate() {
      if (!this.author.rate) return ''

      return this.author.rate !== 100 ? `収益の分配率：${parseFloat(this.author.rate).toFixed(1)}%` : '収益の分配率：100%'
    },
  },
  mounted() {
    this.author_roles = this.mapRoles(this.author.pivot.author_roles)
  },
  methods: {
    handleRoleChange(role) {
      this.$emit('update', { index: this.index, role })
    },
    isDisabled() {
      return this.author && this.author?.operation?.checkboxDisabled
    },
    mapRoles(inputArray) {
      return inputArray
        .filter(role => role.checked)
    },
  },
}
</script>
<style scoped>
.disabled-checkbox::before {
  background-color: #c0c0c0;
}
.disabled-checkbox::after {
  background-color: #c0c0c0;
}

.form-label {
  width: 340px;
}

.checkbox {
  margin-right: 0%;
  width: 34%;
}

.copyright-split-rate {
  width: 287px;
}

.tooltip-icon {
  margin-top: 10px;
}

@media screen and (max-width: 895px) {
  .form-label label{
    font-size: 22px;
  }

  .form-item {
    display: flex;
    margin-bottom: 3%;
    margin-top: 3%;
  }

  .copyright-split-rate {
    width: 100%;
  }
}

</style>
